export const customBlacklistedTerms: string[] = [
  "lmafo",
  "lmao",
  "lmfao",
  "wtf",
  "damn",
];

export const customWhitelistedTerms: string[] = ["assess", "assist"];
